// import { computed, makeObservable } from 'mobx';
import injectStores from '../RootStore/injectStores';

// import PropTypes from 'prop-types';
import { PureComponent } from 'react';
// import List from './List';

interface ListRenderRowProps {
  customRowRenderer: (props: any) => JSX.Element;
  index: number;
  isScrolling: boolean;
  rowKey: string;
  style: object;
  rows: any[];
}

interface ListRenderRowRendererProps {
  key: string;
  customRowRenderer: (props: any) => JSX.Element;
  index: number;
  isScrolling: boolean;
  style: object;
  rows: any[];
}

class ListRenderRow extends PureComponent<ListRenderRowProps> {
  // constructor(props) {
  //   super(props);
  //   makeObservable(this, {
  //     currentRowData: computed
  //   });
  // }
  get currentRowData() {
    const { rows, index } = this.props;
    if (!rows[index]) return {};
    return { ...rows[index] };
  }
  render() {
    const {
      customRowRenderer: CustomRowRenderer,
      index,
      isScrolling,
      rowKey,
      style,
    } = this.props;
    if (CustomRowRenderer)
      return (
        <CustomRowRenderer
          index={index}
          isScrolling={isScrolling}
          key={rowKey}
          rowKey={rowKey}
          style={style}
          rowData={this.currentRowData}
        />
      );
    return (
      <div key={rowKey} style={style}>
        <div>Row {index + 1}</div>
      </div>
    );
  }
}

// ListRenderRow.propTypes = {
//   customRowRenderer: PropTypes.func,
//   index: PropTypes.number.isRequired,
//   isScrolling: PropTypes.bool,
//   rowKey: PropTypes.string,
//   style: PropTypes.object,
//   rows: PropTypes.array.isRequired,
// };
const RenderRow = injectStores(ListRenderRow);

const listRenderRowRenderer = (props: ListRenderRowRendererProps) => {
  const { key, ...rest } = props;
  return <RenderRow key={key} rowKey={key} {...rest} />;
};

export default listRenderRowRenderer;
